import { IScaffoldActionPreviewRowHeightChange, ScaffoldState } from "./interface";

/**
 * Handles the PREVIEW_ROW_HEIGHT_CHANGE action by storing or clearing a transient
 * row height override used during a resize drag session.
 *
 * When height is null, the entry for rowId is removed from previewRowHeights.
 * When height matches the existing value, the state is returned unchanged.
 * Otherwise, the new height is merged into previewRowHeights.
 *
 * @param action - The PREVIEW_ROW_HEIGHT_CHANGE action carrying the rowId and new height (or null to clear).
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the preview height applied or removed.
 */
export const scr_previewRowHeightChange = <T>(
  action: IScaffoldActionPreviewRowHeightChange,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  if (action.height === null) {
    if (!(action.rowId in state.previewRowHeights)) {
      return state;
    }

    const { [action.rowId]: _removed, ...remaining } = state.previewRowHeights;
    return { ...state, previewRowHeights: remaining };
  }

  if (state.previewRowHeights[action.rowId] === action.height) {
    return state;
  }

  return {
    ...state,
    previewRowHeights: { ...state.previewRowHeights, [action.rowId]: action.height },
  };
};
